/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useResource } from "~/views/resources/ResourceProvider";
import { ResourceScheduleCalendar } from "~/views/timeline/components";

export function ScheduleTab() {
  const { resource } = useResource();

  return <ResourceScheduleCalendar resourceId={resource?.id ?? ""} />;
}
